{
  "ancillaries": {
    "toaster": {
      "errorSavingPriority": "We were unable to save your changes to priority services. Please try again."
    },
    "priority": {
      "extraTitle": "Priority services",
      "select": "Add",
      "selected": "Added",
      "eligibility": {
        "notAvailableBus": "Unfortunately, priority services <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, priority services <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      },
      "noPriorityAvailable": "No priority services available for this part of your journey.",
      "inCart": "Added to the cart",
      "paid": "Confirmed",
      "alreadyPurchased": "Priority services has already been purchased for this passenger.",
      "additionalInfoBlockNotificationHel": "Please note that families with children can use a separate security lane provided by Helsinki airport <b>free of charge</b>. If this applies to you, you do not need to purchase this service additionally from us."
    }
  },
  "services": {
    "priority": {
      "maxedPurchasesNotification": "You have added the maximum number of priority services for this flight.",
      "noQuotaLeft": "All available spots for priority services are taken for this part of your journey.",
      "title": "Priority services",
      "state": {
        "updating": {
          "ariaText": "Confirming your selection for priority services"
        },
        "purchased": {
          "default": "No priority services confirmed yet",
          "plural": "{numberOfItems} x Priority services confirmed",
          "singular": "1 x Priority services confirmed"
        },
        "selection": {
          "default": "No priority services selected yet",
          "plural": "{numberOfItems} Priority services waiting in the cart",
          "singular": "1 Priority services waiting in the cart"
        },
        "select": {
          "ariaText": "Purchase priority services",
          "text": "Select"
        },
        "modify": {
          "ariaText": "Modify priority services selection",
          "text": "Modify"
        }
      }
    }
  }
}
